export default __webpack_public_path__ + "static/media/xp.b62dc3a6.png";